<script lang="ts">
  import type { OrgaViewFrameContext } from "../../../../context"
  import UsersTab from "./tabs/users"
  import RolesTab from "./tabs/roles"

  const {
    viewFrameContext,
    activeTab,
  }: {
    viewFrameContext: OrgaViewFrameContext
    activeTab: string
  } = $props()

  const organization = $derived(viewFrameContext.organization)
  const canViewUsers = $derived(viewFrameContext.permissions.allows("core.memberships", "view"))
  const canViewRoles = $derived(viewFrameContext.permissions.allows("core.roles", "view"))
</script>

{#if organization && canViewUsers}
  <!-- Data and dialogs belong to exactly one organization; another one remounts the tab. -->
  {#key organization.id}
    {#if activeTab === "roles"}
      {#if canViewRoles}
        <RolesTab {viewFrameContext} {organization} />
      {/if}
    {:else}
      <UsersTab {viewFrameContext} {organization} />
    {/if}
  {/key}
{/if}
